import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingFarmPrimaryData } from "services";

import { footprintingFarmPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_FARM_PRIMARY_DATA } from "consts";

export const useSubmitFootprintingFarmPrimaryData = (farmId: string, year: number, primaryDataId: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_FARM_PRIMARY_DATA, farmId, year, isAdmin],
      mutationFn: async () => setFootprintingFarmPrimaryData({ farmId, year, isSubmitted: true }, primaryDataId),
      onSuccess: async () => {
        invalidateAndRefecthQueries(queryClient, [...footprintingFarmPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin)]);
      },
    },
    queryClient
  );
};
